<template>
  <div>
    <h1>Portal DDS Digital</h1>
    <div class="ibox animated fadeInRightBig mt-2">
      <div class="ibox-title">Dashboard</div>
      <div class="ibox-content" style="min-height: 400px">
        <div class="row">
          <div class="col-md-9">
            <div class="card">
              <div class="card-header">
                <div class="card-title mb-2">
                  Participação dos Colaboradores
                  <br />
                  <span class="subtitle"
                    >Quantidade de Convites X Quantidade de Confirmações de
                    Presença</span
                  >
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <BarChart
                      id="Chart1"
                      class="centered"
                      v-if="load"
                      :chart-data="dashboard.chart1"
                      :options="options1"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-12">Percentual de Participação</div>
              <div class="col-md-12">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Mês</th>
                      <th scope="col">Percentual</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pct in dashboard.chart1.percentual" :key="pct">
                      <td scope="row" align="center">{{ pct.month }}</td>
                      <td>{{ pct.pc }}%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ibox-title mt-2">Dashboard</div>
      <div class="ibox-content" style="min-height: 400px">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <div class="card-title mb-2">
                  Ranking por Áreas
                  <span class="subtitle"
                    >Áreas com maior participação nas reuniões de DDS.</span
                  >
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <BarChart
                      id="Chart1"
                      class="centered"
                      v-if="load"
                      :chart-data="dashboard.chart2"
                      :options="options1"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ibox-title mt-2">Dashboard</div>
      <div class="ibox-content" style="min-height: 400px">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <div class="card-title mb-2">
                  Ranking por Temas
                  <span class="subtitle"
                    >Temas com maior participação nas reuniões de DDS.</span
                  >
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <BarChart
                      id="Chart"
                      class="centered"
                      v-if="load"
                      :chart-data="dashboard.chart3"
                      :options="options1"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./Charts/BarChart.js";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    BarChart,
    Datepicker,
  },
  data: function () {
    return {
      load: false,
      dashboard: {},
      chart1: {
        labels: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ],
        datasets: [
          {
            label: "Reservados",
            backgroundColor: "#FFB22B",
            borderColor: "#FFB22B",
            borderWidth: 3,
            radius: 5,
            data: [0, 25, 50, 75, 100, 125],
          },
          {
            label: "Retirados",
            backgroundColor: "#1B9E77",
            borderColor: "#1B9E77",
            borderWidth: 4,
            radius: 5,
            pointBorderColor: "1B9E77",
            data: [0, 25, 50, 75, 100, 125],
          },
        ],
      },
      options1: {
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
    };
  },
  methods: {
    getDashboards() {
      const self = this;
      const api = self.$store.state.api + "dashboard";

      self.$http.post(api).then(function (response) {
        self.dashboard = response.data;
        self.load = true;
      });
    },
  },
  mounted() {
    const self = this;
    self.getDashboards();
  },
};
</script>
<style scoped>
.card-title {
  font-size: 16px !important;
  font-weight: bold;
}
.subtitle {
  font-size: 14px !important;
  font-style: italic;
  font-weight: 400;
}
.mt-2 {
  margin-top: 2rem;
}
.mt-3 {
  margin-top: 3rem;
}
.mb-2 {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue